module.exports = __webpack_public_path__ + "static/scale-model-of-prudential-outdoor-learning-in-newark-new-jersey-c0842564917cd50a9d9142e635153b1c.png";